module.exports = __webpack_public_path__ + "img/US.b717af7.svg";